import mainJs from "../wwwroot/app/UL/main"
import footer from "./app/Footer.js"
import faq from "./app/faq"
import { MeasureHistory } from "../wwwroot/app/UL/MeasureHistory.js"
import { AddServiceAccount } from "../wwwroot/app/UL/AddServiceAccount.js"
import cityPicker from "./app/CityPicker.js"
import cityPickerMobile from "./app/CityPickerMobile.js"
import mainSlider from './app/main-slider/main-slider'
import profiles from "./app/profiles/profiles"
import pay from "./app/pay/pay"
import register from './app/register/register'
import helpInfoPage from "./app/HelpInfoPage.js"
import fl from "./app/fl/index"
import flppu from "./app/fl/ppu/ppu-index.js"
import union from './app/union/union.js'

// global variables

var epp = window.epp || (window.epp = {});

epp.measureHistory = MeasureHistory;
epp.addServiceAccount = AddServiceAccount;



// WEBPACK FOOTER //
// ./Scripts/main.js